<ng-container [formGroup]="stepForm">

  <mat-form-field appearance="outline" [hideRequiredMarker]="true">
    <mat-label>Adres e-mail</mat-label>
    <input
      matInput
      type="email"
      [formControl]="email"
      required
      autocomplete="email"
      tabindex="0"
      appGtmFormEvent
      (keydown.enter)="onSubmit()"
      [eventField]="'email'"
      [eventForm]="formName"
    />

    <mat-error *ngIf="email.invalid && (email.dirty || !email.untouched)">
      <span *ngIf="email.errors.required">Wpisz e-mail</span>
      <span *ngIf="email.errors.invalidEmail"> Wpisz prawidłowy adres e-mail</span>
      <span *ngIf="email.errors.maxlength">Adres e-mail jest za długi</span>
    </mat-error>
  </mat-form-field>
  <app-statements [statements]="statemates"
                  [submitted]="submitted"
                  [initialValue]="acceptedRegulations.value"
                  formControlName="acceptedRegulations">
  </app-statements>
  <div class="actions">
    <app-new-loader-button
      [disabled]="loading || (submitted && !stepForm.valid)"
      (buttonClick)="onSubmit()"
      [loading]="loading"
      class="auth-button"
      id="register-button"
      [customType]="LoaderButtonType.RAISED"
      color="accent">
      Dalej
    </app-new-loader-button>
  </div>
  <footer fxLayout="row" class="footer">
    <p class="h3-regular">
      Masz już konto? <a class="h3-regular" queryParamsHandling="preserve" routerLink="/auth/login">Zaloguj się</a>
    </p>
  </footer>
</ng-container>
